import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import HomePage from './pages/public/HomePage';
import EnterpriseOptions from './pages/public/EnterpriseOptions';
import ForgotPassword from './pages/public/ForgotPassword';
import ResetPassword from './pages/public/ResetPassword';
import Dashboard from './pages/private/Dashboard';
import PrivateRoute from './auth/PrivateRoute';
import PublicRoute from './auth/PublicRoute';
import { AuthProvider } from './auth/AuthContext';
import Settings from './pages/private/Settings';
import PageNotFound from './pages/public/PageNotFound';
import ExpectedValueCalculator from './pages/private/calculators/ExpectedValueCalculator';
import TrueOddsCalculator from './pages/private/calculators/TrueOddsCalculator';
import KellyCriterionCalculator from './pages/private/calculators/KellyCriterionCalculator';
import BackLayCalculator from './pages/private/calculators/BackLayCalculator';
import DutchingCalculator from './pages/private/calculators/DutchingCalculator';
import BookieDatabase from './pages/private/BookieDatabase';
import Login from './pages/public/Login';
import SignUp from './pages/public/SignUp';
import './styles/variables.css';
import './App.css';
import ConversionWizard from './pages/public/ConversionWizard';
import MugMaster from './pages/public/MugMaster';
import BetslipsTips from './pages/public/BetslipsTips'; // Import the new component

// ScrollToTop function
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force scroll to top when the pathname changes - make sure applies on all browsers
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0; 
  }, [pathname]);

  return null;
}

function App() {

  // Add this useEffect to disable browser's scroll restoration
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  return (
    <AuthProvider>
      <Router>
        {/* Include ScrollToTop component here */}
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/forgot-password" element={<MainLayout><ForgotPassword /></MainLayout>}  />
          <Route path="/reset-password" element={<MainLayout><ResetPassword /></MainLayout>}  />
          <Route path="/enterprise" element={<MainLayout><EnterpriseOptions /></MainLayout>} />
          <Route path="/conversion-wizard" element={<MainLayout><ConversionWizard /></MainLayout>} />
          <Route path="/mug-master" element={<MainLayout><MugMaster /></MainLayout>} />
          <Route path="/betslips-tips" element={<MainLayout><BetslipsTips /></MainLayout>} />
          <Route path="/calculators/expected-value" element={<MainLayout><ExpectedValueCalculator /></MainLayout>} />
          <Route path="/calculators/true-odds" element={<MainLayout><TrueOddsCalculator /></MainLayout>} />
          <Route path="/calculators/kelly-criterion" element={<MainLayout><KellyCriterionCalculator /></MainLayout>} />
          <Route path="/calculators/back-lay" element={<MainLayout><BackLayCalculator /></MainLayout>} />
          <Route path="/calculators/dutching" element={<MainLayout><DutchingCalculator /></MainLayout>} />


          {/* Routes exclusive to unauthorized users */}
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<MainLayout><Login /></MainLayout>} />
            <Route path="/signup" element={<MainLayout><SignUp /></MainLayout>} />
          </Route>

          {/* Private routes with MainLayout */}
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<MainLayout><Dashboard /></MainLayout>} />
            <Route path="/bookie-database" element={<MainLayout><BookieDatabase /></MainLayout>} />
            <Route path="/settings" element={<MainLayout><Settings /></MainLayout>} />
          </Route>
          {/* 404 route */}
          <Route path="*" element={<MainLayout><PageNotFound /></MainLayout>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;